const initPdpInfoScroll = (root) => {
  const info = root.querySelector(".product__info");
  const content = info?.querySelector(".product-info");
  const items = root.querySelectorAll(".product-gallery-item");
  const thirdItem = items[Math.min(2, items.length - 1)];
  const desktop = window.matchMedia("(min-width: 960px)");

  if (!info || !content || !thirdItem || root.pdpInfoScroll) return;

  let previousY = window.scrollY;
  let offset = 0;
  let renderedOffset = null;
  let downScrollStart = 0;
  let maxOffset = 0;
  let scrollFrame = null;
  let measureFrame = null;
  let destroyed = false;

  const render = () => {
    if (renderedOffset === offset) return;
    renderedOffset = offset;
    content.style.setProperty("--pdp-info-offset", `${-offset}px`);
  };

  const measure = () => {
    measureFrame = null;
    if (destroyed) return;

    if (!desktop.matches) {
      offset = 0;
      renderedOffset = null;
      content.style.removeProperty("--pdp-info-offset");
      previousY = window.scrollY;
      return;
    }

    const paddingTop = parseFloat(getComputedStyle(info).paddingTop) || 0;
    downScrollStart =
      thirdItem.getBoundingClientRect().bottom + window.scrollY - window.innerHeight;
    maxOffset = Math.max(0, content.scrollHeight + paddingTop - window.innerHeight);
    offset = Math.min(offset, maxOffset);
    previousY = window.scrollY;
    render();
  };

  const scheduleMeasure = () => {
    if (measureFrame === null) {
      measureFrame = requestAnimationFrame(measure);
    }
  };

  const update = () => {
    scrollFrame = null;
    const currentY = window.scrollY;
    const delta = currentY - previousY;

    if (!desktop.matches) {
      previousY = currentY;
      return;
    }

    if (delta < 0) {
      offset = Math.max(0, offset + delta);
    } else if (delta > 0 && currentY > downScrollStart) {
      const syncedDelta =
        previousY < downScrollStart ? currentY - downScrollStart : delta;
      offset = Math.min(maxOffset, offset + syncedDelta);
    }

    previousY = currentY;
    render();
  };

  const onScroll = () => {
    if (scrollFrame === null) {
      scrollFrame = requestAnimationFrame(update);
    }
  };

  const resizeObserver = new ResizeObserver(scheduleMeasure);
  resizeObserver.observe(content);
  resizeObserver.observe(thirdItem);
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", scheduleMeasure);
  desktop.addEventListener("change", scheduleMeasure);

  root.pdpInfoScroll = {
    destroy() {
      destroyed = true;
      resizeObserver.disconnect();
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", scheduleMeasure);
      desktop.removeEventListener("change", scheduleMeasure);
      if (scrollFrame !== null) cancelAnimationFrame(scrollFrame);
      if (measureFrame !== null) cancelAnimationFrame(measureFrame);
      content.style.removeProperty("--pdp-info-offset");
      delete root.pdpInfoScroll;
    },
  };

  measure();
};

const getPdpRoots = (scope = document) =>
  scope.matches?.(".section-product")
    ? [scope]
    : scope.querySelectorAll(".section-product");

const initAllPdpInfoScroll = (scope = document) => {
  getPdpRoots(scope).forEach(initPdpInfoScroll);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initAllPdpInfoScroll());
} else {
  initAllPdpInfoScroll();
}

document.addEventListener("shopify:section:load", (event) =>
  initAllPdpInfoScroll(event.target)
);

document.addEventListener("shopify:section:unload", (event) => {
  getPdpRoots(event.target).forEach((root) => root.pdpInfoScroll?.destroy());
});
